import FormExtension from "@/core/components/FormExtension"
import { mapState } from "vuex"

export default FormExtension.extend({})